<script lang="ts">
  import type { SerializedParagraphBlock } from '../../types'

  let { block }: { block: SerializedParagraphBlock } = $props()
</script>

<p class="paragraph-block">{block.text}</p>

<style>
  /* Fills the page's content column instead of the narrower global paragraph measure. */
  .paragraph-block {
    max-width: none;
  }
</style>
